/**
 * 3DSv2 device fingerprint for Revolut CIT charges.
 *
 * Sent inside saved_payment_method.environment when calling
 * POST /api/orders/{id}/payments with initiator=customer. Required by
 * Revolut for PSD2 SCA — without it the API returns a misleading
 * 400 "Required 'browserData' is missing". The actual field is
 * `environment` (snake_case sub-fields), see Pay-for-order docs.
 */
export function collectBrowserData(): Record<string, unknown> {
  const nav = window.navigator;
  const screen = window.screen;
  return {
    type: 'browser',
    // Local-offset returned by Date is negative for ahead-of-UTC zones;
    // Revolut wants the human-readable UTC offset in minutes (e.g. 180 = +03:00).
    time_zone_utc_offset: -new Date().getTimezoneOffset(),
    color_depth: screen?.colorDepth ?? 24,
    screen_width: screen?.width ?? 0,
    screen_height: screen?.height ?? 0,
    java_enabled: false,
    // 640 is the standard 3DS challenge popup width.
    challenge_window_width: 640,
    browser_url: window.location.origin,
  };
}
